(function () {
  // Kya ye item free (BOGO) hai? -> property mein "bxgy": true
  function isFreeItem(item) {
    var raw = item && item.properties && item.properties.__kaching_bundles;
    if (!raw) return false;
    try {
      return JSON.parse(raw).bxgy === true;
    } catch (e) {
      return /"bxgy"\s*:\s*true/.test(String(raw));
    }
  }

  // Body mein free items se selling_plan hata do
  function fixBody(body) {
    if (typeof body !== 'string') return body;
    try {
      var data = JSON.parse(body);
      if (!data || !Array.isArray(data.items)) return body;

      data.items.forEach(function (item) {
        if (isFreeItem(item)) delete item.selling_plan;   // sirf free item
      });
      return JSON.stringify(data);
    } catch (e) {
      return body;
    }
  }

  var isCartAdd = function (url) { return /\/cart\/add/.test(String(url)); };

  // fetch wali requests
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (input && input.url) || input;
    if (isCartAdd(url) && init && init.body) {
      init = Object.assign({}, init, { body: fixBody(init.body) });
    }
    return origFetch.call(this, input, init);
  };

  // XMLHttpRequest / jQuery wali requests
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._isCartAdd = isCartAdd(url);
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this._isCartAdd) body = fixBody(body);
    return origSend.call(this, body);
  };
})();
